import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Combo } from "../../types/common.types";

interface ComboState {
  combos: Combo[];
  selectedCombo: Combo | null;
}

const initialState: ComboState = {
  combos: [],
  selectedCombo: null,
};

export const ComboSlice = createSlice({
  name: "combo",
  initialState,
  reducers: {
    setCombos: (state, action: PayloadAction<Combo[]>) => {
      state.combos = action.payload;
    },
    addCombo: (state, action: PayloadAction<Combo>) => {
      state.combos.push(action.payload);
    },
    updateCombo: (state, action: PayloadAction<Combo>) => {
      const index = state.combos.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) {
        state.combos[index] = action.payload;
      }
    },
    removeCombo: (state, action) => {
      state.combos = state.combos.filter(
        (combo) => combo.id !== action.payload
      );
    },
    setSelectedCombo: (state, action: PayloadAction<Combo | null>) => {
      state.selectedCombo = action.payload;
    },
  },
});

export const {
  setCombos,
  addCombo,
  updateCombo,
  removeCombo,
  setSelectedCombo,
} = ComboSlice.actions;

export default ComboSlice.reducer;
